import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PoeDataService {

  private dataSource = new BehaviorSubject({});
  poeData = this.dataSource.asObservable();
  private accessToken: BehaviorSubject<string> = new BehaviorSubject<string>("");
  private invoices = new BehaviorSubject([]);
  invoicesData = this.invoices.asObservable();
  constructor() { }

  setPoeMetaData(val: object) {
    this.dataSource.next(val);
  }
  getPoeMetaData() {
    return this.dataSource;
  }
  SetAccessToken(val: string) {
    this.accessToken.next(val);
  }
  GetAccessToken() {
    return this.accessToken;
  }
  changeTheme(background: string, font: string) {
    document.documentElement.style.setProperty('--dynamic-bg-colour', background);
    document.documentElement.style.setProperty('--dynamic-font-color', font); 
  }
  SetInvoices(val: any) {
    this.invoices.next(val);
  }
}
